export default {
  methods: {
    getFullName(firstName, lastName) {
      if (!firstName && !lastName) return "Profile"
      return `${firstName || ""} ${lastName || ""}`
    },
  },
}
